import { Fragment, useState, useEffect } from "react";
import { Card, CardBody, CardHeader, CardTitle, Col, FormGroup, Label, Row, Button } from "reactstrap";
import * as Yup from "yup";
import Datetime from "react-datetime";
import SelectUf from "../../../../../components/Select/SelectUf/index";
import SelectMunicipioSouLegal from "../../../../../components/Select/SelectMunicipioSouLegal/index";
import { options as optionsUf } from "../../../../../components/Select/SelectUf/options";
import { options as optionsMunicipio } from "../../../../../components/Select/SelectMunicipioSouLegal/options";

const Step2 = ({ values, setValues, setCurrentStep }) => {
  const [ufLocalVendaValue, setUfLocalVendaValue] = useState();
  const [municipioLocalVendaValue, setMunicipioLocalVendaValue] = useState();

  const renderInputDatePicker = (props, openCalendar) => {
    return (
      <div className="form-control datePicker d-flex justify-content-between align-items-center">
        <input {...props} name="scheduleTo" className="" readOnly style={{border:'none'}}/>
        <i className="fa-solid fa-calendar-days cursor-pointer" onClick={openCalendar} />
      </div>
    );
  };

  const validationSchema = Yup.object().shape({
    uf_local_venda: Yup.string().required('A UF da Venda é obrigatória').uppercase().oneOf(['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'], "Campo UF da Venda inválido"),
    municipio_local_venda: Yup.string().required("Campo Município da Venda é obrigatório"),
    data_venda: Yup.string().required("Data Data da Venda é obrigatório")
  });

  const validate = async () => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });

      setErrors({});
      setValues(formData);
      setCurrentStep(2);
      return true;
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });

      setErrors(validationErrors);

      return false;
    }
  };

  const handleSetUfLocalVendaValue = (value) => {
    const _ufLocalVendaValue = optionsUf.find(uf => uf.value === value);
    setUfLocalVendaValue(_ufLocalVendaValue);
  }

  const handleSetMunicipioLocalVendaValue = (value) => {
    const _municipioLocalVendaValue = optionsMunicipio.find(municipio => municipio.value === value);
    setMunicipioLocalVendaValue(_municipioLocalVendaValue);
  }

  const handleSetDataVenda = (date) => {
    setFormData({
      ...formData,
      data_venda: date
    });
  };

  const handlePrevious = () => {
    setValues(formData);
    setCurrentStep(0);
  }

  useEffect(() => {
    if (values.uf_local_venda) {
      handleSetUfLocalVendaValue(values.uf_local_venda);
    }

    if (values.municipio_local_venda) {
      handleSetMunicipioLocalVendaValue(values.municipio_local_venda);
    }

    setFormData({
      uf_local_venda: values.uf_local_venda,
      municipio_local_venda: values.municipio_local_venda,
      data_venda: values.data_venda
    });
  }, [values])

  const [formData, setFormData] = useState({
    uf_local_venda: '',
    municipio_local_venda: '',
    data_venda: ''
  });

  const [errors, setErrors] = useState({
    uf_local_venda: '',
    municipio_local_venda: '',
    data_venda: ''
  });

  const setFieldValue = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Fragment>
      <Card className="border-custom">
        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados da Venda</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="uf_local_venda"><span className="text-danger">***</span> UF</Label>
                <SelectUf
                  name="uf_local_venda"
                  id="uf_local_venda"
                  placeholder="Selecione a UF"
                  className={errors.uf_local_venda ? " is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("uf_local_venda", data ? data.value : ""); handleSetUfLocalVendaValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={ufLocalVendaValue}
                />
                <div className="invalid-feedback">{errors.uf_local_venda}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="municipio_local_venda"><span className="text-danger">***</span> Município</Label>
                <SelectMunicipioSouLegal
                  name="municipio_local_venda"
                  placeholder="Selecione um Município"
                  className={errors.municipio_local_venda ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("municipio_local_venda", data ? data.value : ""); handleSetMunicipioLocalVendaValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={municipioLocalVendaValue}
                />
                <div className="invalid-feedback">{errors.municipio_local_venda}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="data_venda"><span className="text-danger">***</span> Data</Label>
                <Datetime
                  id="data_venda"
                  name="data_venda"
                  value={formData.data_venda}
                  locale="pt-br"
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnClickOutside={true}
                  renderInput={renderInputDatePicker}
                  onChange={handleSetDataVenda}
                  className={(errors.data_venda ? "is-invalid invalid-multi-select" : "")}
                />
                <div className="invalid-feedback">{errors.data_venda}</div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div className="text-center">
        <Button className="mr-1" color="primary" onClick={() => handlePrevious()}>Anterior</Button>
        <Button className="mr-1" color="primary" onClick={validate}>Próximo</Button>
      </div>
    </Fragment>
  );
};

export default Step2;